import { RtuReachabilityPoint, RtuReachabilityResponse } from '../types/RtuReachability';

/** Concise Reachability explanation for the info tooltip (Bug 3140). */
export const REACHABILITY_INFO_TOOLTIP_DEFAULT =
  'Reachability summarizes all persisted automatic and manual checks during the selected period. A check is fully successful only when every configured attempt succeeds; partial success is not fully successful and corresponds to Unstable. Latest Interval is the most recent chart interval. Latest Ping Result separately shows the newest detailed ping run and its attempts.';

export const formatCheckSuccessRatePercent = (rate: number | null | undefined): string =>
  `${Number(rate ?? 0).toFixed(1)}%`;

/**
 * Latest Interval uses the most recent chart bucket. When that bucket has no checks,
 * show "-" instead of a misleading 0%.
 */
export const formatLatestIntervalPercent = (
  rate: number | null | undefined,
  latestIntervalChecks: number | null | undefined
): string => {
  if (latestIntervalChecks == null || latestIntervalChecks <= 0) {
    return '-';
  }
  return formatCheckSuccessRatePercent(rate);
};

export const getLatestIntervalPoint = (
  data: RtuReachabilityResponse | null | undefined
): RtuReachabilityPoint | null => {
  const points = data?.points;
  if (!points || points.length === 0) {
    return null;
  }
  return points[points.length - 1] ?? null;
};

export const getLatestIntervalChecks = (
  data: RtuReachabilityResponse | null | undefined
): number => getLatestIntervalPoint(data)?.totalChecks ?? 0;
